const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const fetchMuteReasons = () => {
        return async () => {
            try {
                const response = await axiosCall.get('/muteReasons');
                return response.data;
            } catch (error) {
                console.error(error);
            }
        };
    };

    return {
        fetchMuteReasons,
    };
};

export default initActions;
